import { defineComponent, ref, useModel, openBlock, createElementBlock, Fragment, createVNode, unref, withModifiers, withCtx, renderList, normalizeClass, createElementVNode, toDisplayString, createCommentVNode, normalizeStyle, createBlock, mergeModels, nextTick, toRaw } from 'vue';
import { ElForm, ElInput, ElButton } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
import InfiniteScroll from '../../../component/infinite-scroll/infinite-scroll.js';
import _sfc_main$1 from '../../../component/player/player.vue.js';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
import { Search } from '@element-plus/icons-vue';
import { SelectList, ListWrapper } from '@ssml-editor/vue';
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import { BgmContentData } from './data.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "bgm-content",
  props: /* @__PURE__ */ mergeModels({
    bgmPageSize: { default: 10 },
    bgmCategoryPageSize: { default: 10 },
    fetchBgms: { type: Function, default: () => Promise.resolve([]) },
    fetchCategories: { type: Function, default: () => Promise.resolve([]) },
    searchBgms: { type: Function }
  }, {
    "modelValue": {
      default: new BgmContentData()
    },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const showSearchResult = ref(false);
    const showMusicList = ref(false);
    const searchInput = ref("");
    const categoryDataList = ref([]);
    const musicDataList = ref([]);
    const searchMusicDataList = ref([]);
    const searchMusic = ref();
    const bgmContentData = useModel(__props, "modelValue");
    function getMusicName(music, musicDataList2) {
      for (const s of musicDataList2) {
        if (s.value === music) {
          return s.label;
        }
      }
    }
    function searchInputHandler(value) {
      if (value.trim() === "") {
        showSearchResult.value = false;
        searchMusicDataList.value = [];
      } else {
        showSearchResult.value = true;
      }
    }
    function categoryValueChangeHandler() {
      showMusicList.value = false;
      nextTick(() => {
        showMusicList.value = true;
      });
    }
    async function fetchMusicList(page) {
      const bgms = await __props.fetchBgms({
        page,
        category: bgmContentData.value.category
      });
      return bgms.map((item) => ({
        label: item.name,
        value: item.src
      }));
    }
    async function categoryChangeHandler(categoryData) {
      showMusicList.value = false;
      if (categoryData.length > 0) {
        categoryDataList.value = categoryData;
        if (!bgmContentData.value.category || !categoryData.some((item) => item.value === bgmContentData.value.category)) {
          bgmContentData.value.category = categoryData[0].value;
        }
        nextTick(() => {
          showMusicList.value = true;
        });
      }
    }
    async function musicChangeHandler(musicData) {
      if (musicData.length > 0) {
        musicDataList.value = musicData;
        if (!bgmContentData.value.music || !musicData.some((item) => item.value === bgmContentData.value.music)) {
          bgmContentData.value.music = musicData[0].value;
        }
      }
    }
    async function searchSubmitHandler() {
      searchMusic.value = void 0;
      searchMusicDataList.value = [];
      const bgms = __props.searchBgms ? await __props.searchBgms({
        word: searchInput.value
      }) : [];
      if (bgms.length > 0) {
        searchMusicDataList.value = bgms.map((item) => ({
          label: item.name,
          value: item.src
        }));
        searchMusic.value = bgms[0].src;
      }
    }
    function musicSelectHandler(item) {
      bgmContentData.value.music = item.value;
    }
    function searchMusicSelectHandler(item) {
      searchMusic.value = item.value;
    }
    function getData() {
      let musicName = void 0;
      if (showSearchResult.value) {
        if (searchMusic.value) {
          musicName = getMusicName(searchMusic.value, searchMusicDataList.value);
        }
        return { music: searchMusic.value, musicName };
      } else {
        const data = toRaw(bgmContentData.value);
        if (data.music) {
          musicName = getMusicName(data.music, musicDataList.value);
        }
        return { ...data, musicName };
      }
    }
    __expose({
      getData
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.searchBgms ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "se-bgm-content-search"
        }, [
          createVNode(unref(ElForm), {
            onSubmit: withModifiers(searchSubmitHandler, ["prevent"])
          }, {
            default: withCtx(() => [
              createVNode(unref(ElInput), {
                modelValue: searchInput.value,
                "onUpdate:modelValue": ($event) => searchInput.value = $event,
                placeholder: "搜索背景音乐",
                clearable: "",
                onInput: searchInputHandler
              }, {
                append: withCtx(() => [
                  createVNode(unref(ElButton), {
                    onClick: searchSubmitHandler,
                    icon: unref(Search)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          showSearchResult.value ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "se-bgm-content-search-result"
          }, [
            createVNode(unref(SelectList), {
              modelValue: searchMusic.value,
              "onUpdate:modelValue": ($event) => searchMusic.value = $event,
              "data-list": searchMusicDataList.value
            }, {
              default: withCtx(({ model, dataList }) => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(dataList, (item, index) => {
                  return openBlock(), createElementBlock("p", {
                    class: normalizeClass(["se-music-item", { activated: item.value === model }]),
                    title: item.label,
                    key: index,
                    onClick: ($event) => searchMusicSelectHandler(item)
                  }, [
                    createVNode(unref(_sfc_main$1), {
                      src: item.value.toString()
                    }, null, 8, ["src"]),
                    createElementVNode("span", { class: "se-text" }, toDisplayString(item.label), 1)
                  ], 10, ["title", "onClick"]);
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue", "data-list"])
          ])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", {
          class: "se-bgm-content-body",
          style: normalizeStyle({ display: showSearchResult.value ? "none" : "flex" })
        }, [
          createVNode(unref(ListWrapper), { title: "类型" }, {
            default: withCtx(() => [
              createVNode(unref(InfiniteScroll), {
                modelValue: bgmContentData.value.category,
                "onUpdate:modelValue": [($event) => bgmContentData.value.category = $event, categoryValueChangeHandler],
                "page-size": __props.bgmCategoryPageSize,
                load: __props.fetchCategories,
                onChange: categoryChangeHandler
              }, null, 8, ["modelValue", "onUpdate:modelValue", "page-size", "load"])
            ]),
            _: 1
          }),
          createVNode(unref(ListWrapper), { title: "音乐" }, {
            default: withCtx(() => [
              showMusicList.value ? (openBlock(), createBlock(unref(InfiniteScroll), {
                key: 0,
                modelValue: bgmContentData.value.music,
                "onUpdate:modelValue": ($event) => bgmContentData.value.music = $event,
                "page-size": __props.bgmPageSize,
                load: fetchMusicList,
                onChange: musicChangeHandler
              }, {
                default: withCtx(({ model, dataList }) => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(dataList, (item, index) => {
                    return openBlock(), createElementBlock("p", {
                      class: normalizeClass(["se-music-item", { activated: item.value === model }]),
                      title: item.label,
                      key: index,
                      onClick: ($event) => musicSelectHandler(item)
                    }, [
                      createVNode(unref(_sfc_main$1), {
                        src: item.value.toString()
                      }, null, 8, ["src"]),
                      createElementVNode("span", { class: "se-text" }, toDisplayString(item.label), 1)
                    ], 10, ["title", "onClick"]);
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onUpdate:modelValue", "page-size"])) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 4)
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=bgm-content.vue2.js.map
